<template>
  <div
    :style="{
      width: direction === 'horizontal' ? 'calc(100% - 10px) !important' : '100%',
    }"
    :class="direction === 'horizontal' ? 'p-5 flex items-center' : ''"
    class="cursor-pointer overflow-hidden rounded-12 bg-white shadow"
    @click="$push({
      path: '/course/courseDetail',
      query: {
        id: data.objectId || '&&&&&'
      },
    })"
  >
    <!-- 图片 -->
    <van-image
      :width="direction === 'horizontal' ? '50%' : '100%'"
      height="auto"
      lazy-load
      :src="data.coverPicture || ''"
      fit="cover"
      :class="direction === 'horizontal' ? 'rounded-12 overflow-hidden' : ''"
    />
    <div
      :style="{ width: direction === 'horizontal' ? 'calc(50% - 10px) !important' : '100%' }"
      :class="direction === 'horizontal' ? 'h-auto pl-10' : 'p-10 h-110'"
    >
      <!-- 标题 -->
      <div class="text-13 line-height-22 line-2">
        {{ data.title ? data.title : '该课程不存在' }}
      </div>
      <!-- 简介 -->
      <div
        class="mt-5 text-11 line-height-22 text-gray line-1"
      >
        {{ data.introduction ? data.introduction : '暂无简介' }}
      </div>
      <!-- 金额 -->
      <div class="flex items-center justify-between">
        <div
          v-if="data.price"
          class="mt-8 text-14 font-bold line-height-14 text-orange"
        >
          <span class="text-10">￥</span>{{ data.price }}
        </div>
        <div
          v-else
          class="mt-8 text-14 font-bold line-height-14 text-orange"
        >
          免费
        </div>
        <div
          v-if="data.price > 0 && isShowExchangeCount"
          class="text-10 text-gray"
        >
          {{ `${count}人兑换` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CourseCard',
  data () {
    return {
      exchangeCount: 0,
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          title: '',
          price: 0,
          objectId: '',
          introduction: '',
          coverPicture: '',
          exchangeQuantity: 0
        }
      },
    },
    direction: {
      type: String,
      default: 'vertical',
    },
  },
  computed: {
    ...mapGetters(['isShowExchangeCount']),
    count () {
      return this.data.exchangeQuantity || this.exchangeCount
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      if (!this.data.objectId) { return }
      if (!this.isShowExchangeCount) { return }
      this.exchangeCount = await this.statisticsNum('exchangeRecord', {
        course: this.data.objectId,
        status: '已使用',
      })
    },
  },
}
</script>

<style scoped lang="scss">
</style>
